import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { Subscription } from 'rxjs';
import { HeaderComponent } from './shared/components/header/header.component';
import { ModalHostComponent } from './shared/components/modal-host/modal-host.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { IUser } from './shared/models/user.model';
import { AuthService } from './shared/services/auth.service';
import { HelperService } from './shared/services/helper.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalHostComponent, ToastModule, SidebarComponent, HeaderComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  currentUser: IUser | null = null;
  subscription = new Subscription();

  constructor(
    public router: Router,
    public helperService: HelperService,
    public authService: AuthService
  ) {
    this.subscription.add(
      this.authService.currentUser$.subscribe(user => {
        this.currentUser = user;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Routes that render chrome-free (no sidebar, header, or shell padding): the login screen and the
   * production TV board, which fills the whole screen.
   */
  get hideDefaultLayout(): boolean {
    return this.router.url.includes('login') || this.router.url.includes('delivery-dates-overview');
  }
}
